import { TransportJobsApiService } from 'core/api';
import { ITransportJobDao } from 'core/api/types/transport-job.interface';
import { useDocument } from 'core/hooks/useDocument';
import { useParams } from 'react-router-dom';
import PageHeader from 'shared/components/page-header/page-header';
import PageHeaderSkeleton from 'shared/components/page-header/page-header-skeleton';
import TransportJobDetails from './transport-job-overview-details/transport-job-overview-details';
import { useState } from 'react';
import TransportJobOverviewProof from './transport-job-overview-proof/transport-job-overview-proof';
import SharedTabButton from 'shared/components/buttons/tab-button/tab-button';

const TransportJobOverview = () => {
  const { uid } = useParams();
  const { data, loading } = useDocument<ITransportJobDao>({
    apiService: TransportJobsApiService,
    uid,
  });
  const [selectedTab, setSelectedTab] = useState<string>('proof');

  const tabs = [
    {
      label: 'Proof of delivery',
      key: 'proof',
    },
  ];

  const getTabContent = (job: ITransportJobDao) => {
    switch (selectedTab) {
      case 'proof':
        return <TransportJobOverviewProof job={job} />;
    }
  };

  return (
    <>
      {!data || loading ? (
        <PageHeaderSkeleton actions={[]} subtitle={true} />
      ) : (
        <>
          <PageHeader title='Transport Job' showBack={true} />
          <div className='flex flex-row py-6'>
            <TransportJobDetails job={data} />
            <div className='pl-6 w-full'>
              <div className='relative'>
                <div className='flex relative z-10'>
                  {tabs.map((tab) => (
                    <SharedTabButton key={tab.key} changeTab={setSelectedTab} tab={tab} currentTab={selectedTab} />
                  ))}
                </div>
                <div className='absolute bottom-0 left-0 right-0 h-px bg-gray-200' />
              </div>
              <div className='mt-6'>{getTabContent(data)}</div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TransportJobOverview;
